import React, {useEffect, useState} from 'react';
import {Form, Text} from 'react-aria-components';
import {LuCheckSquare, LuClock, LuCog, LuHardHat, LuKey, LuSquare} from "react-icons/lu";
import {Navigate} from "react-router-dom";

import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import {LabeledSection, LabeledTextField} from "../../components/Fields/LabeledTextField.jsx";
import DefaultButton, {SecondaryButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import api from "../../utils/api";

import './SyntheticUserCreate.css';
import SelectableRoles, {SelectedRoles} from "../../components/SelectableRoles/SelectableRoles";
import {toast} from "react-toastify";


function SyntheticUserCreate() {
    const [submitting, setSubmitting] = React.useState(false)
    const [name, setName] = useState("");
    const [roles, setRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [redirectTo, setRedirectTo] = useState(null);

    useEffect(() => {
        api.listRoles().then((data) => {
            setRoles(data);
        })
    }, []);

    if (redirectTo) {
        return <Navigate to={redirectTo} />
    }

    if (submitting) {
        return <Text>Submitting...</Text>
    }

    function onNameChange(e) {
        setName(e.target.value);
    }

    function onPassword1Change(e) {
        setPassword1(e.target.value);
    }

    function onPassword2Change(e) {
        setPassword2(e.target.value);
    }

    function submit() {
        if (password1 !== password2) {
            toast.warn("Passwords do not match");
            return;
        }
        setSubmitting(true);
        const roleIds = selectedRoles.map((role) => role.id);
        const body = {
            name: name,
            password: password1,
            role_ids: roleIds
        }
        api.createSyntheticUser(body).then((result) => {
            setSubmitting(false);
            if (result) {
                setRedirectTo("/users");
            }
        })
    }

    const content = <div id="synthetic-user-create">
    <LabeledSection label="General" icon={<LuCog/>} className="general-settings">
        <LabeledTextField
            label="Name"
            value={name}
            placeholder="User Name"
            onChange={onNameChange}
            name="name"
            errorLoc={["body", "name"]}
            hiddenLabel={false}
        />
        <SelectableRoles
            roles={roles}
            selectedRoles={selectedRoles}
            setSelectedRoles={setSelectedRoles}
            showLabel={true}
        />
    </LabeledSection>


    <LabeledSection label="Password" icon={<LuKey/>} className="password-settings">
        <LabeledTextField
            label="Password"
            value={password1}
            placeholder="New Password"
            onChange={onPassword1Change}
            name="password1"
            errorLoc={["body", "password"]}
            inputType={"password"}
            hiddenLabel={false}
        />
        <LabeledTextField
            label="Confirm Password"
            value={password2}
            placeholder="Repeat Password"
            onChange={onPassword2Change}
            name="password2"
            errorLoc={[]}
            inputType={"password"}
            hiddenLabel={false}
        />
    </LabeledSection>

    <div className="save-row">
        <SecondaryButton
            className="cancel-button"
            text="Cancel"
            href="/users"
        />
        <DefaultButton text="Save" onPress={submit} oneClick />
    </div>
</div>

return <FullWidthLayout
    title="Create User"
    mainContent={content}
/>
}

export default SyntheticUserCreate;